import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Root} from "./Root";
import './i18n';

// IMPORTANT! if needed italic font, import it here
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '@fontsource/roboto-mono/400.css';
import '@fontsource/roboto-mono/500.css';
import '@fontsource/roboto-mono/600.css';
import '@fontsource/roboto-mono/700.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(<Root />);

reportWebVitals();
